import React, { Component } from 'react';
import axios from 'axios'
import $ from 'jquery'
import Headers from '../Layouts/Headers'
import { InterModularSidebar } from '../Layouts/InterModularSidebar'
export class SendToModule extends Component {
    constructor(props) {
		super(props);
		const url = ''

		this.state = {

			module: '',
			profession: '',
			name: '',
			nationality: '',
			loading: false

		}

		this.handleSubmit = this.handleSubmit.bind(this);
		this.handleChange = this.handleChange.bind(this);
	}
	handleChange(event) {
		this.setState({ [event.target.name]: event.target.value });

	}

	handleSubmit = event => {
		event.preventDefault()
		var moduleSelected = this.state['module']
		console.log(module)
		const headers = {
			'Content-Type': 'application/json',
			'token': localStorage.getItem('accessToken'),
			'visitid': localStorage.getItem('currentVisitId')
		}

		this.setState({
			loading: true
		})
		axios.post(this.api_url+"billing/status/" + moduleSelected + "/open", this.state, { headers: headers })
			.then(res => {
				//   const verified = res.data;
				console.log(res.data);
				this.setState({
					loading: false
				})
				if (res.data['status']) {
					$('#sendModuleSuccess').show()
					setTimeout(function (props) {
						$('.modal').hide()

					}, 3000);
				}
			})
			.catch(error => {
				this.setState({
					loading: false
				})
				console.log(error)
			})
		axios.post(this.api_url+"billing/status/"+localStorage.getItem('currentModule')+"/closed", this.state, { headers: headers })
			.then(res => {
				//   const verified = res.data;
				console.log(res.data);
				this.setState({
					loading: false
				})
				if (res.data['status']) {
				
					$('#sendModuleSuccess').show()
					setTimeout(function (props) {
						$('.modal').hide()
                        $('.logoImg').click();
                        
						
					}, 30);
				}
			})
			.catch(error => {
				this.setState({
					loading: false
				})
				console.log(error)
			})

	}





	componentDidMount() {


		console.log(localStorage.getItem('currentVisitId'))
		console.log(localStorage.getItem('currentVisitName'))
		console.log(localStorage.getItem('currentVisitNationality'))
		console.log(localStorage.getItem('currentVisitProfession'))
		console.log(localStorage.getItem('currentModule'))

		$('.'+localStorage.getItem('currentModule')).hide()
		//     const article = { title: 'React POST Request Example' };   
		// axios.post('https://reqres.in/api/articles', article)
		// .then(response => this.setState({ articleId: response.data.id }));

		$('.sendToModule').on('click', function () {
			$('.module_list').show();
		})
	}


	render() {

		const font16 = { fontSize: '16px' };
		const fontFamilyNunito = { fontFamily: 'Nunito, sans-serif' }
		const floatRight = { float: 'right' }
		const floatLeft = { float: 'left' }
		const displayHidden = { display: 'none' }
		let forgotPasswordUrl = '/forgot/password';
		const { module, loading } = this.state;
		

		
		return (
			<div>
				<Headers />
				<InterModularSidebar/>
                <main className="content-container ">

<div className="container p-2">
    <form onSubmit={this.handleSubmit}>
        <div className="form-row pt-4">

        <div className="col-md-4 text-lg-center font-weight-bold p-1">
                                </div>

                                <div className="col-md-4 p-2">
                                    <h2 className="center text-capitalize" >Send Patient To Specific Module</h2>
                                    <div className="card pt-5 pr-5 pl-5 ">

										
												<div className="py-1">
													<h6 className="text-capitalize" style={fontFamilyNunito}>Choose Module</h6><select onChange={this.handleChange} value={module} name="module" className="form-control selectModule" required>
														<optgroup label="">
															<option selected disabled></option>
															<option className="option-select lab" value="lab">Laboratory</option>
															<option className="option-select gynecology" value="gynecology" >Gynecology Ward I</option>
															<option className="option-select gynecology2" value="gynecology2" >Gynecology Ward II</option>
															<option className="option-select labour" value="labour" >Labour Room </option>
															<option className="option-select delivery" value="delivery">Delivery </option>
															<option className="option-select newborn" value="newborn">New Born Unit </option>
															<option className="option-select theatre" value="theatre">Theatre </option>															


															<option className="option-select triage" value="triage">Triage</option>
															<option className="option-select Post-natal" value="Post-natal">Post-Natal</option>
														</optgroup>
													</select>
												</div>
												<div id='sendModuleSuccess' className="alert alert-success" style={displayHidden} role="alert">
                            <strong>Success!  </strong>Details were saved Successfuly.
                        </div>
                                                <div className="row">
											{/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
											<div className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold" type="submit" style={floatLeft}>{loading ? 'Loading' :'Submit'}</button></div>
										</div>

											</div>

                                            </div>
										
                                        </div>
                        </form>
                    </div>

                </main>


</div>

    )
  }
}

export default SendToModule